export class SearchResult<T> {
  constructor(public readonly results: T[], public readonly total: number, public readonly  offset: number) {

  }
}
